"use strict";

/* eslint-disable func-names */
/* eslint-disable no-extend-native */
/* eslint-disable prefer-rest-params */
/**
 * How to use:
 *
 * "Hello, {name}, are you feeling {adjective}?".formatUnicorn({name:"Gabriel", adjective: "OK"});
 * --> Hello, Gabriel, are you feeling OK?
 *
 * "a{0}bcd{1}ef".formatUnicorn("foo", "bar");
 * --> "aFOObcdBARef"
 */
String.prototype.formatUnicorn = String.prototype.formatUnicorn || function () {
  var str = this.toString();
  if (arguments.length) {
    var t = typeof arguments[0];
    var args = t === 'string' || t === 'number' ? Array.prototype.slice.call(arguments) : arguments[0];
    Object.keys(args).forEach(function (key) {
      str = str.replace(new RegExp("\\{" + key + "\\}", 'gi'), args[key]);
    });
  }
  return str;
};